module.exports = __webpack_public_path__ + "media/svg-new/bossHappy-0aef8692.svg";